import {
  doGet,
  doPost,
} from '@/http/index.js';
import axios from 'axios';

const actions = {
  getWeights: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/get-weights',
        method: 'GET',
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
  deleteWeight: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/api/delete-weight/${ id }`,
        method: 'DELETE',
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
  setWeight: ({ commit }, requestData) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/set-weight',
        data: requestData,
        method: 'POST',
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
};

export default {
  namespaced: true,
  actions,
};
